import type { DataSourceDataDTO } from '@conversed/rest/src/contracts/data-sources/data-sources.dto';
import { useDataSourceActions } from '@hooks/dataSources/useDataSourceActions';
import { useDataSources } from '@hooks/dataSources/useDataSources';
import type React from 'react';
import { DataSourceDataModal } from './DataSourceDataModal';

export const EditDataSource: React.FC = () => {
  const { updateDataSourceDetails } = useDataSourceActions();
  const { selectedDataSourceFile, dataSources } = useDataSources();

  const onSubmit = async (data: DataSourceDataDTO) => {
    if (selectedDataSourceFile?.key) {
      await updateDataSourceDetails({
        key: selectedDataSourceFile.key,
        name: data.name,
        trainingStatus: selectedDataSourceFile.trainingStatus,
        label: data.label,
        expiryDate: data.expiryDate,
      });
    }
  };

  return (
    <DataSourceDataModal
      selectedDataSource={selectedDataSourceFile}
      onSubmit={onSubmit}
      mode='edit'
      dataSources={dataSources}
    />
  );
};

export default EditDataSource;
